// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","form":"form-28NCF","email":"email-1PyMf","phone__input":"phone__input-3Knva","email__input":"email__input-1ijF8","button":"button-kz0AO"};